"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const DiscountsController_module_scss_1 = __importDefault(require("./DiscountsController.module.scss"));
const DiscountEditor_1 = __importDefault(require("../DiscountEditor"));
function DiscountsController({ discountsArr, onValidStateChange, onDiscountsChange }) {
    const { t } = (0, react_i18next_1.useTranslation)('customer');
    const discountsStates = discountsArr.map((discount) => {
        return { discount, isValid: true, isDateOverlapping: false };
    });
    const isDateBetween = (date, startDate, endDate) => {
        return date >= startDate && (!endDate || date <= endDate);
    };
    const isStartDatesOverlapping = (startDate, discountsState) => {
        return isDateBetween(startDate, discountsState.discount.startDate, discountsState.discount.expirationDate);
    };
    const isExpirationDatesOverlapping = (expirationDate, discountsState) => {
        return ((!expirationDate && !discountsState.discount.expirationDate) ||
            (expirationDate &&
                isDateBetween(expirationDate, discountsState.discount.startDate, discountsState.discount.expirationDate)));
    };
    const updateOverlappingDatesState = (discountStates) => {
        const overlappingDiscountIndexes = new Set();
        for (let i = 0; i < discountStates.length; i++) {
            for (let j = i + 1; j < discountStates.length; j++) {
                if (isStartDatesOverlapping(discountStates[i].discount.startDate, discountStates[j]) ||
                    isExpirationDatesOverlapping(discountStates[i].discount.expirationDate, discountStates[j])) {
                    overlappingDiscountIndexes.add(i);
                    overlappingDiscountIndexes.add(j);
                }
            }
            discountStates[i] = Object.assign(Object.assign({}, discountStates[i]), { isDateOverlapping: overlappingDiscountIndexes.has(i) });
        }
    };
    updateOverlappingDatesState(discountsStates);
    const [discounts, setDiscounts] = (0, react_1.useState)(discountsStates);
    const [temporaryId, setTemporaryId] = (0, react_1.useState)(-1);
    const [areAllDiscountsValid, setAreAllDiscountsValid] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        onValidStateChange(areAllDiscountsValid);
    }, [areAllDiscountsValid]);
    (0, react_1.useEffect)(() => {
        onDiscountsChange(discounts.map((discountSate) => discountSate.discount));
    }, [discounts]);
    const addDiscount = () => {
        setTemporaryId((prevTemporaryId) => prevTemporaryId - 1);
        setDiscounts((prevDiscounts) => {
            const newDiscounts = prevDiscounts.slice();
            const now = new Date(Date.now());
            newDiscounts.push({
                discount: {
                    id: temporaryId,
                    extrusionsDiscount: 0,
                    componentsDiscount: 0,
                    machiningDiscount: 0,
                    startDate: now,
                    expirationDate: new Date(now.getFullYear(), 11, 31),
                },
                isValid: false,
                isDateOverlapping: !!prevDiscounts.length,
            });
            updateOverlappingDatesState(newDiscounts);
            return newDiscounts;
        });
        setAreAllDiscountsValid(false);
    };
    const onDiscountChange = (discount) => {
        setDiscounts((prevDiscounts) => {
            const newDiscounts = prevDiscounts.slice();
            const oldDiscountState = newDiscounts.find((discountState) => discountState.discount.id === discount.id);
            const index = newDiscounts.indexOf(oldDiscountState);
            newDiscounts[index] = Object.assign(Object.assign({}, oldDiscountState), { discount });
            updateOverlappingDatesState(newDiscounts);
            return newDiscounts;
        });
    };
    const updateValidState = (newDiscounts) => {
        setAreAllDiscountsValid(newDiscounts.every((discount) => discount.isValid));
    };
    const onDiscountValidStateChange = (id, isValid) => {
        setDiscounts((prevDiscounts) => {
            const newDiscounts = prevDiscounts.slice();
            const oldDiscountState = newDiscounts.find((discountState) => discountState.discount.id === id);
            const index = newDiscounts.indexOf(oldDiscountState);
            newDiscounts[index] = Object.assign(Object.assign({}, oldDiscountState), { isValid });
            updateValidState(newDiscounts);
            return newDiscounts;
        });
    };
    const onDiscountDelete = (id) => {
        setDiscounts((prevDiscounts) => {
            const newDiscounts = prevDiscounts.slice();
            const index = newDiscounts.indexOf(newDiscounts.find((discount) => discount.discount.id === id));
            newDiscounts.splice(index, 1);
            updateValidState(newDiscounts);
            updateOverlappingDatesState(newDiscounts);
            return newDiscounts;
        });
    };
    return (react_1.default.createElement("div", { className: DiscountsController_module_scss_1.default.content },
        react_1.default.createElement("div", { className: DiscountsController_module_scss_1.default.title, onClick: addDiscount, onKeyDown: (e) => e.key === 'Enter' && addDiscount(), tabIndex: 0, role: "button" },
            t('actions.add-discounts'),
            react_1.default.createElement("img", { src: assets_1.svgBasicAddNewDark, alt: "plus sign" })),
        react_1.default.createElement("div", { className: DiscountsController_module_scss_1.default.block }, discounts
            ? Array.from(discounts.values()).map((discountState) => {
                const { discount } = discountState;
                return (react_1.default.createElement("div", { className: DiscountsController_module_scss_1.default.discount, key: discount.id },
                    react_1.default.createElement(DiscountEditor_1.default, { discount: discount, onValidStateChange: onDiscountValidStateChange, onDiscountChange: onDiscountChange, onDiscountDelete: onDiscountDelete, isDateOverlaping: discountState.isDateOverlapping })));
            })
            : null)));
}
exports.default = DiscountsController;
